import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { gridPageSelector, gridPageSizeSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { selectTaskSearchData } from '@AMIEWEB/Tasks/store/Tasks.selectors';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { Pagination } from 'app/ComponentLibrary/Pagination/Pagination';
import { TASKS_DEFAULT_PAGE_SIZE } from '@AMIEWEB/GlobalSearch/SearchResultsPage';

export interface ModsLinkTaskSearchGridPaginationProps {
  loading?: boolean;
}

/** DataGridPro slot: syncs MUI page state with grid Redux + task search paging total. */
export const ModsLinkTaskSearchGridPagination: React.FC<ModsLinkTaskSearchGridPaginationProps> = ({ loading }) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const taskSearchData = useSelector(selectTaskSearchData);
  const dispatch = useDispatch();

  const rowCount = taskSearchData?.paging?.total || 0;

  return (
    <Pagination
      isLoading={loading ?? false}
      handleResultsPerPageChange={(value, _page) => {
        dispatch(gridStateActions.setPageSize(value));
        dispatch(gridStateActions.setPageNumber(1));
        apiRef?.current?.setPageSize(value);
        apiRef?.current?.setPage(0);
      }}
      handlePageChange={(value, _) => {
        dispatch(gridStateActions.setPageNumber(value));
        apiRef?.current?.setPage(value - 1);
      }}
      pageOptions={[50, 100, 150, 200, 250]}
      pagination={{
        page: (page || 0) + 1,
        resultsPerPage: pageSize || TASKS_DEFAULT_PAGE_SIZE,
        totalResults: rowCount,
      }}
    />
  );
};
